
import { generateTextReportPDF } from '../../../../pdf/GenerateTextReportPDF';
import TextReportHeader from "../../../../HecoReports/TextReport/Utils/TextReportHeader";


export default function handleDownloadPDF(checkboxStates) {
  // Retrieve data from localStorage
  const companyName = localStorage.getItem('companyName');
  const timestamp = localStorage.getItem('timestamp');

  if (checkboxStates.selectTextualReport) {
    // Use the custom hook to get the textReportHeader data
    const textReportHeader = TextReportHeader();

    if (textReportHeader) {
      // Generate the PDF report
      const reportPDF = generateTextReportPDF(companyName, timestamp, textReportHeader);

      if (reportPDF) {
        // Save the PDF with a specific name
        const initialFileName = localStorage.getItem('initialFileName');
        reportPDF.save(`${initialFileName}-textual-report.pdf`);
      } else {
        console.error("Error: Generated PDF is null");
      }
    } else {
      console.error("Error: Text report header is null");
    }
  }
}
